<div>
  <serviceRequestLog-item *ngFor="let p of serviceRequests" [serviceRequest]="p"></serviceRequestLog-item>
</div>